import Vue from 'vue';
import Router from 'vue-router';
import Main from './views/Main.vue';
import About from './views/About.vue';
import Services from './views/Services.vue';
import ServiceItem from './components/common/serviceItem/ServiceItem.vue';
import Products from './views/Products.vue';
import ProductsCategory from './components/common/productsCategory/ProductsCategory.vue';
import ProductItem from './components/common/productItem/ProductItem.vue';
import Questionnaires from './views/Questionnaires.vue';
import Facilities from './views/Facilities.vue';
import FacilityItem from './components/common/facilityItem/FacilityItem.vue';
import Partners from './views/Partners.vue';
import Contacts from './views/Contacts.vue';
import PrivacyPolicy from './views/PrivacyPolicy.vue';
import Page404 from './views/Page404.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [

    {
        path: '/',
        name: 'Main',
        component: Main,
        props: true
    },

    {
        path: '/o-kompanii',
        name: 'About',
        component: About,
        props: true
    },

    {
        path: '/uslugi',
        name: 'Services',
        component: Services,
        props: true
    },

    {
      path: '/uslugi/:type',
      name: 'ServiceItem',
      component: ServiceItem,
      props: true
    },

    {
      path: '/tovary',
      name: 'Products',
      component: Products,
      props: true
    },

    {
      path: '/tovary/:type',
      name: 'ProductsCategory',
      component: ProductsCategory,
      props: true
    },

    {
      path: '/tovary/:type/:item',
      name: 'ProductItem',
      component: ProductItem,
      props: true
    },

    {
      path: '/oprosnye-listy',
      name: 'Questionnaires',
      component: Questionnaires,
      props: true
    },

    {
      path: '/nashi-obekty',
      name: 'Facilities',
      component: Facilities,
      props: true
    },

    {
      path: '/nashi-obekty/:type',
      name: 'FacilityItem',
      component: FacilityItem,
      props: true
    },

    {
      path: '/partnyory',
      name: 'Partners',
      component: Partners,
      props: true
    },

    {
      path: '/kontakty',
      name: 'Contacts',
      component: Contacts,
      props: true
    },

    {
        path: '/politika-konfidencial-nosti',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
        props: true
    },

    {
      path: '*',
      name: 'Page404',
      component: Page404,
      props: true
    }
  ]
})
